import { Component, Input } from '@angular/core';
import { Variable } from '../../model/variable/variable';
import { VariableValue } from '../../model/variable/variable-value';
import { ComponentVariable } from '../component-variable';


const HTML_TEMPLATE = `
<span class="var-title">{{variable.description}}</span>
<div class="var-value-label" padding-top>
	<span class="{{getLegendClass()}}">
		<span>{{variableValue.asString}}</span>
		<span *ngIf="variable.suffix && variableValue.asString != undefined" class="var-suffix">{{variable.suffix}}</span>
	</span>
</div>
`;

const CSS_STYLE = `
.var-value-label {
    min-height: 59px;
}
`;

@Component({
    selector: 'variable-formula',
    template: HTML_TEMPLATE,
    styles: [CSS_STYLE]
})
export class VariableFormulaComponent extends ComponentVariable {

    @Input('variable') variable: Variable;
    @Input('callbackOnChange') callback: Function;
    variableValue: VariableValue;

    constructor() {
        super();

        this.variableValue = {
            asBoolean: false,
            asString: "0",
            value: 0
        }
    }

    ngOnInit() {
        this.onChangeCallback();
    }

    getValue() {
        return this.variableValue;
    }

    setValue(variableValue: VariableValue): void {
        if (variableValue) {
            this.variableValue = variableValue;
            
            if (typeof (this.variableValue.value) == 'number') {
                this.variableValue.asString = this.variableValue.value.toFixed(this.variable.decimals);
            }
        }
    }

    getVariable(): Variable {
        return this.variable;
    }

    onChangeCallback(): void {
        this.callback(this);
    }

}
